import { render, staticRenderFns } from "./confirmation.vue?vue&type=template&id=4c2a2344&scoped=true"
import script from "./confirmation.vue?vue&type=script&lang=js"
export * from "./confirmation.vue?vue&type=script&lang=js"
import style0 from "./confirmation.vue?vue&type=style&index=0&id=4c2a2344&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a2344",
  null
  
)

export default component.exports